import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';

// Get the current hostname to handle custom domains
const hostname = typeof window !== 'undefined' ? window.location.hostname : '';

// VibeCraft Firebase configuration
// Note: The project ID contains a unique suffix (5c54c) but the app is branded as VibeCraft
const firebaseConfig = {
  apiKey: 'AIzaSyCJqdTDRTWmpUpgV4d_J_XOl24XIxloj_w',
  // Use the current hostname as the authDomain if it's one of our domains
  // This ensures cookies are set on the correct domain
  authDomain:
    hostname === 'vibecraft.space'
      ? 'vibecraft.space'
      : hostname === 'vibecraft-5c54c.web.app'
      ? 'vibecraft-5c54c.web.app'
      : hostname.includes('vibecraft-5c54c--')
      ? hostname // Use the preview channel hostname directly
      : 'vibecraft-5c54c.firebaseapp.com',
  projectId: 'vibecraft-5c54c',
  storageBucket: 'vibecraft-5c54c.appspot.com',
  messagingSenderId: '934369953970',
  appId: '1:934369953970:web:73e5250b29c30ba71661ab',
  measurementId: 'G-1WL23CQ0N0',
};

// Log the hostname for debugging


// Initialize Firebase with better error handling
let app: any;
try {
  // Initialize with app check for production domains
  if (
    hostname === 'vibecraft.space' ||
    hostname === 'vibecraft-5c54c.web.app' ||
    hostname === 'vibecraft-5c54c.firebaseapp.com'
  ) {
    
  }

  // Delete any existing apps to avoid conflicts
  const apps = getApps();
  if (apps.length > 0) {
    
    app = apps[0];
  } else {
    app = initializeApp(firebaseConfig);
    
  }
} catch (error) {
  
  // If already initialized, use the existing app
  if (error.code === 'app/duplicate-app') {
    
    const apps = getApps();
    app = apps.length > 0 ? apps[0] : initializeApp(firebaseConfig);
  } else {
    throw error;
  }
}

// Initialize Analytics - only in production
let analytics = null;
if (typeof window !== 'undefined' && import.meta.env.PROD) {
  analytics = getAnalytics(app);
}

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Set auth persistence to SESSION to avoid CORS issues
import { setPersistence, browserSessionPersistence, GoogleAuthProvider } from 'firebase/auth';

// Set persistence to SESSION (instead of LOCAL) to avoid CORS issues
try {
  setPersistence(auth, browserSessionPersistence)
    .then(() => {
      
    })
    .catch((error) => {
      
    });
} catch (error) {
  
}

export const googleProvider = new GoogleAuthProvider();

// Configure Google provider for better UX
googleProvider.setCustomParameters({
  prompt: 'select_account',
});

export { analytics };
export default app;

